<template>
  <div class="classmate-page">
    <Header />
    <div class="page-header">
      <img v-if="isPC" class="page-header-text" src="@/assets/images/classmate/pc_img_classmate_02.png">
      <img v-else class="page-header-text" src="@/assets/images/classmate/sp_img_classmate_02.png">
    </div>
    <section class="heading-tag">
      <div class="heading-tag-body">
        <div class="heading-tag-head"><img src="@/assets/images/header/pc_icon_header.png"><span style="color: #2692d5">日向坂総合高校</span></div>
      </div>
    </section>
    <div class="classmate-wrap">
      <div class="classmate-nav">
        <ul>
          <li @click="onClickGrade(3)"><div :class="['classmate-nav-div', { 'active' : currentGrade === 3 }]">3年生</div></li>
          <li @click="onClickGrade(2)"><div :class="['classmate-nav-div', { 'active' : currentGrade === 2 }]">2年生</div></li>
          <li @click="onClickGrade(1)"><div :class="['classmate-nav-div', { 'active' : currentGrade === 1 }]">1年生</div></li>
        </ul>
      </div>
      <div v-if="currentClassmates.length > 0" class="classmate-icon-wrap">
        <div class="classmate-icon" v-for="classmate in currentClassmates" :key="classmate.id" @click="currentId = classmate.id">
          <div class="classmate-icon-img">
            <img v-if="isPC" :src="require(`@/assets/images/classmate/pc_icon_member_${classmate.id}.png`)">
            <img v-else :src="require(`@/assets/images/classmate/sp_icon_member_${classmate.id}.png`)">
          </div>
          <p class="classmate-name">{{ classmate.name }}</p>
        </div>
      </div>
      <div v-else class="coming-soon-message">
        <p>coming soon</p>
      </div>
    </div>
    <div class="classmate-popup" v-if="currentId">
      <div class="classmate-popup-bg"></div>
      <div class="classmate-popup-close" @click="currentId = null">
        <img src="@/assets/images/classmate/pc_btn_close.png" alt="">
      </div>
      <div class="classmate-popup-main">
        <img v-if="isPC" :src="require(`@/assets/images/classmate/pc_img_member_${currentId}.png`)">
        <img v-else :src="require(`@/assets/images/classmate/sp_img_member_${currentId}.png`)">
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import resolution from '@/mixin/resolution';
export default {
  name: 'ClassmatePage',
  components: {
    Header,
    Footer
  },
  mixins: [resolution],
  computed: {
    currentClassmates() {
      return this.classmates.filter((classmate) => {
        return classmate.grade === this.currentGrade;
      });
    }
  },
  data() {
    return {
      classmates: [
        { id: '201', grade: 3, name: '金村 美玖' },
        { id: '202', grade: 3, name: '河田 陽菜' },
        { id: '203', grade: 3, name: '小坂 菜緒' },
        { id: '204', grade: 3, name: '富田 鈴花' },
        { id: '207', grade: 3, name: '松田 好花' },
        { id: '301', grade: 2, name: '上村 ひなの' },
        { id: '302', grade: 2, name: '髙橋 未来虹' },
        { id: '303', grade: 2, name: '森本 茉莉' },
        { id: '304', grade: 2, name: '山口 陽世' },
        { id: '401', grade: 2, name: '石塚 瑶季' },
        { id: '403', grade: 2, name: '小西 夏菜実' },
        { id: '404', grade: 2, name: '清水 理央' },
        { id: '405', grade: 2, name: '正源司 陽子' },
        { id: '406', grade: 2, name: '竹内 希来里' },
        { id: '407', grade: 2, name: '平尾 帆夏' },
        { id: '408', grade: 2, name: '平岡 海月' },
        { id: '409', grade: 2, name: '藤嶌 果歩' },
        { id: '410', grade: 2, name: '宮地 すみれ' },
        { id: '411', grade: 2, name: '山下 葉留花' },
        { id: '412', grade: 2, name: '渡辺 莉奈' },
        { id: '501', grade: 1, name: '大田 美月' },
        { id: '502', grade: 1, name: '大野 愛実' },
        { id: '503', grade: 1, name: '片山 紗希' },
        { id: '504', grade: 1, name: '蔵盛 妃那乃' },
        { id: '505', grade: 1, name: '坂井 新奈' },
        { id: '506', grade: 1, name: '佐藤 優羽' },
        { id: '507', grade: 1, name: '下田 衣珠季' },
        { id: '508', grade: 1, name: '高井 俐香' },
        { id: '509', grade: 1, name: '鶴崎 仁香' },
        { id: '510', grade: 1, name: '松尾 桜' },
      ],
      currentGrade: 3,
      currentId: null
    }
  },
  methods: {
    onClickGrade(grade) {
      this.currentGrade = grade;
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  background-image: url('@/assets/images/classmate/pc_img_classmate_01.png');
  background-size: contain;
  background-repeat: no-repeat;
  aspect-ratio: 480 / 133;
  display: flex;
  justify-content: center;
  align-items: center;
  .page-header-text {
    width: 20%;
  }
}
.classmate-wrap {
  text-align: center;
}

.classmate-nav {
  margin-bottom: 60px;
  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    li {
      list-style: none;
      &:not(:last-child) {
        margin-right: 50px;
        position: relative;
      }
      .classmate-nav-div {
        width: 100px;
        font-size: 24px;
        cursor: pointer;
        color: #484848;
        &.active {
          color: #2692d5;
          border-bottom: 3px solid #2692d5;
          padding-bottom: 10px;
        }
      }
    }
  }
}
.coming-soon-message {
  font-size: 42px;
  margin-bottom: 48px;
}
.classmate-icon-wrap {
  width: 75%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .classmate-icon {
  flex-basis: 25%;
  margin: 25px 0px;
  cursor: pointer;
  .classmate-name {
    margin: 25px 0px;
    font-size: 18px;
    color: #484848;
  }
  .classmate-icon-img {
    position:relative;
    img {
      position:relative;
      width: 18.5vw;
      max-width:200px;
    }
    &:before {
      opacity: 0;
      content: '';
      position: absolute;
      display:inline-block;
      background: url("@/assets/images/classmate/pc_icon_member_on.png") no-repeat;
      background-size: contain;
      width: 12vw;
      height: 12vw;
      max-width: 160px;
      max-height: 160px;
      z-index: -1;
    }
  }
  &:hover {
    .classmate-name {
      color: #5ba7f2;
    }
    .classmate-icon-img {
      &:before {
        -webkit-transition: all 0.3s;
        -moz-transition:    all 0.3s;
        -ms-transition:     all 0.3s;
        -o-transition:      all 0.3s;
        transition:         all 0.3s;
        opacity: 1;
        top: 2vh;
        left: calc( 6vw - 1vh );
      }
    }
  }
  &.classmate-icon-coming {
    .classmate-icon-img {
      &:before {
        display: none;
      }
    }
  }
}
}

.classmate-popup {
  img {
    width: 100%;
  }
  .classmate-popup-bg {
    background: linear-gradient( to bottom, #65bbfe, #68ffef );
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    box-sizing: border-box;
    opacity: 0.5;
  }
  .classmate-popup-close {
    position: fixed;
    top: 10vh;
    right: 14.3vw;
    z-index: 1001;
    cursor: pointer;
    width: 3vw;
  }
  .classmate-popup-main {
    position: fixed;
    width: 68vw;
    top: 11vh;
    left: 18%;
    z-index: 1000;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 1023px) {
  .page-header {
    background-image: url('@/assets/images/classmate/sp_img_classmate_01.png');
    aspect-ratio: 48 / 29;
    .page-header-text {
      width: 35%;
    }
  }
  .classmate-nav {
    margin-bottom: 10px;
    ul {
      li {
        &:not(:last-child) {
          margin-right: 30px;
        }
        .classmate-nav-div {
          width: 80px;
          font-size: 18px;
        }
      }
    }
  }
  .classmate-icon-wrap {
    width: 100%;
    .classmate-icon {
      flex-basis: 47%;
      margin: 10px 4px;
      font-size: 16px;
      .classmate-name {
        margin: 10px 4px;
        font-size: 16px;
      }
      .classmate-icon-img {
        img {
          width: 144px;
        }
        &:before {
          opacity: 0;
          content: '';
          position: absolute;
          display:inline-block;
          background:url("@/assets/images/classmate/sp_icon_member_on.png") no-repeat;
          background-size:contain;
          width: 105px;
          height: 105px;
          z-index: -1;
        }
      }
      &:hover {
        .classmate-icon-img {
          &:before {
            -webkit-transition: all 0.3s;
            -moz-transition: all 0.3s;
            -ms-transition: all 0.3s;
            -o-transition: all 0.3s;
            transition: all 0.3s;
            opacity: 1;
            top: 15px;
            left: 10vw;
          }
        }
      }
    }
  }
  .classmate-popup {
    .classmate-popup-close {
      top: 27%;
      right: 5%;
      width: 24px;
    }
    .classmate-popup-main {
      width: 90%;
      top: 30%;
      left: 5%;
    }
  }
}
</style>
